/*
 *
 * PayByLinkFilterModal
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 08-Apr-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.filter'
      defaultMessage='Filtri'
    />
  ),
  applyFilters: (
    <PortalMessage
      id='t.app.filter.apply'
      defaultMessage='Applica filtri'
    />
  ),
  resetFilterLabel: (
    <PortalMessage
      id='t.app.filter.reset'
      defaultMessage='Azzera Filtri'
    />
  ),
  titleSectionFacilities: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.facilities.title'
      defaultMessage='Punti vendita'
    />
  ),
  titleSectionLinkStatus: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.linkStatus.title'
      defaultMessage='Stato link'
    />
  ),
  linkStatusOptionAll: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.linkStatus.option.all'
      defaultMessage='Tutti'
    />
  ),
  linkStatusOptionNotPaid: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.linkStatus.option.notPaid'
      defaultMessage='Non pagato'
    />
  ),
  linkStatusOptionPaid: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.linkStatus.option.paid'
      defaultMessage='Pagato'
    />
  ),
  linkStatusOptionFailed: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.linkStatus.option.failed'
      defaultMessage='Negato'
    />
  ),
  linkStatusOptionExpired: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.linkStatus.option.expired'
      defaultMessage='Scaduto'
    />
  ),
  linkStatusOptionPending: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.linkStatus.option.pending'
      defaultMessage='In attesa'
    />
  ),
  titleSectionCreationPeriod: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.creationPeriod.title'
      defaultMessage='Periodo di creazione'
    />
  ),
  subtitleSectionCreationPeriod: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.creationPeriod.subtitle'
      defaultMessage='Puoi visualizzare lo storico dei link generati fino ad un massimo di <b>12 mesi</b>.'
    />
  ),
  datePickerLabelFrom: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.creationPeriod.datePicker.label.from'
      defaultMessage='Da'
    />
  ),
  datePickerLabelTo: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.creationPeriod.datePicker.label.to'
      defaultMessage='A'
    />
  ),
  dateFormatError: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.creationPeriod.datePicker.error'
      defaultMessage='Formato data non valido'
    />
  ),
  outOfRangeError: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.creationPeriod.datePicker.outOfRange'
      defaultMessage='Puoi visualizzare lo storico dei link generati fino ad un massimo di 12 mesi.'
    />
  ),
  startDateAfterTodayError: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.creationPeriod.datePicker.startDateAfterTodayError.error'
      defaultMessage='La data di inizio non può essere successiva alla data odierna'
    />
  ),
  startDateAfterEndDateError: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.creationPeriod.datePicker.startDateAfterEndDate.error'
      defaultMessage='La data di inizio non può essere successiva alla data di fine'
    />
  ),
  endDateAfterTodayError: (
    <PortalMessage
      id='t.app.paybylink.filtersModal.section.creationPeriod.datePicker.endDateAfterTodayError.error'
      defaultMessage='La data di fine non può essere successiva alla data odierna'
    />
  )
}

export default formattedMessage
